import { render, staticRenderFns } from "./BaseFileItem.vue?vue&type=template&id=5f625cc0&scoped=true&"
import script from "./BaseFileItem.vue?vue&type=script&lang=js&"
export * from "./BaseFileItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseFileItem.vue?vue&type=style&index=0&id=5f625cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f625cc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VListItem,VListItemTitle,VMenu})
